import React, { PropsWithChildren, ReactNode } from 'react';
import { PageShell } from '@antonpodolsky/design-system/regions/page-shell/page-shell';
import { SiteNav } from './site-nav';
import { SiteFooter } from './site-footer';

interface Props extends PropsWithChildren {
  header?: ReactNode;
  mainId?: string;
}

export const SitePage = ({ header, mainId, children }: Props) => (
  <PageShell
    header={header ?? <SiteNav />}
    footer={<SiteFooter />}
    mainId={mainId}
  >
    {children}
  </PageShell>
);
